import axios from '../api/axiosInstance';

export const fetchShopProducts = (shopId, params) => {
  return axios.get(`/shops/${shopId}/products`, { params });
};

export const createShopProduct = (shopId, data) => {
  return axios.post(`/shops/${shopId}/products`, data);
};

export const updateShopProduct = (shopId, id, data) => {
  return axios.patch(`/shops/${shopId}/products/${id}`, data);
};

export const deleteShopProduct = (shopId, id, reason) => {
  const payload = reason ? { reason } : {};
  return axios.delete(`/shops/${shopId}/products/${id}`, { data: payload });
};

export const searchProducts = (query, limit = 10) => {
  return axios.get('/products/search', { params: { q: query, limit } });
};

